export const toDate = (date: Date | number): Date => {
  const stringDate = Object.prototype.toString.call(date);

  if (date instanceof Date || (typeof date === 'object' && stringDate === '[object Date]')) {
    return new Date(date.getTime());
  }

  if (typeof date === 'number' || stringDate === '[object Number]') {
    return new Date(date);
  }

  return new Date(NaN);
};

export default toDate;
